import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Tunnel from "./pages/Tunnel/Tunnel";
import Juliette from "./pages/Juliette/Juliette";
import CV from "./pages/CV/CV";
import "./App.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/site" element={<Tunnel />} />
      <Route path="/Juliette" element={<Juliette />} />
      <Route path="/cv" element={<CV />} />
    </Routes>
  );
}

export default App;
